import { render, staticRenderFns } from "./StdSubItemTxtList.vue?vue&type=template&id=36011f5a&"
import script from "./StdSubItemTxtList.vue?vue&type=script&lang=js&"
export * from "./StdSubItemTxtList.vue?vue&type=script&lang=js&"
import style0 from "./StdSubItemTxtList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StdSubItemTxtList.vue"
export default component.exports